import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import {OverlayHelper} from '../../../../helper/overlay.helper';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { BaseCustomDialog } from '../base-custom-dialog';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';
import { ImportComposerLeadRequest } from '../../../../models/leads/leads.model';
import { ToastrService } from 'ngx-toastr';
import { TranslationDirective } from '../../directives/translation.directive';
import { Subscription } from 'rxjs';
import { LeadHelper } from '../../../../helper/lead.helper';

@Component({
  selector: 'fi-create-request-from-composer-dialog',
  templateUrl: './create-request-from-composer-dialog.component.html',
  styleUrls: ['./create-request-from-composer-dialog.component.scss'],
  standalone: false,
})
export class CreateRequestFromComposerDialogComponent extends BaseCustomDialog implements OnInit, OnDestroy {

  generateInProgress = false;
  showCopyView = false;
  copyCode: string;
  showSuccess = false;
  copySuccessMessage: string = '';
  hideCopyButton = false;

  private timeout: ReturnType<typeof setTimeout> | undefined;
  private translationSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<CreateRequestFromComposerDialogComponent>,
    private toastr: ToastrService,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
    @Inject(MAT_DIALOG_DATA) public dialogData: {},
  ) {
    super(dialogRef);
  }

  ngOnInit(): void {
    this.translationSubscription = TranslationDirective.getTranslations().subscribe(translations => {
      this.copySuccessMessage = translations['COMPOSER_LEAD_GENERATED_ID_SUCCESS_MESSAGE']
    });
  }

  ngOnDestroy(): void {
    this.translationSubscription?.unsubscribe();
    OverlayHelper.unfixBody();
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef, true);
    this.dialogRef.close();
  }


  copyToClipboard(showToast: boolean): void {
    if ( !this.copyCode || !navigator?.clipboard?.writeText ) {
      return;
    }

    navigator.clipboard.writeText(this.copyCode).then(() => {
      if (!showToast) {
        this.showSuccess = true;

        if ( this.timeout ) {
          clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
          this.showSuccess = false;
        }, 3000);
      } else {
        this.hideCopyButton = true
        this.showSuccess = false;
        this.showToastMessage();
      }
    }).catch(err => {
      console.error('Clipboard copy failed:', err);
    });
  }


  generateId(): void {
    this.generateInProgress = true;
    const date = new Date();
    const formatted = date.toISOString().split('T')[0];
    const body: ImportComposerLeadRequest = {
      LeadTypeId:  3,
      LeadSourceId:  LeadHelper.IMPORT_COMPOSER_LEAD_SOURCE_ID,
      ContactTypeId: 3,
      LeadDate: formatted,
      LeadText: '',
    }
    this.leadsDataService.importComposerLead(body).subscribe(({ success, data }) => {
      this.generateInProgress = false;
      if (success) {
        this.showCopyView = true;
        this.copyCode = data.Number;
      }
    })
  }


  private showToastMessage(): void {
    this.toastr.success(this.copySuccessMessage, null, {
      closeButton: true,
      positionClass: 'toast-bottom-right',
    });
  }


}
